import Settings from "./Settings";
import type { ISettingsBank } from "./SettingsBank";
import SettingsBank from "./SettingsBank";

export const SettingsHandler = (props: ISettingsBank) => {
    if (props.isBankUser) {
        return <SettingsBank {...props} />;
    }

    return <Settings {...props} />;
};
